import _defineProperty from "/opt/gitlab-runner/builds/4TN/tech/audio/juke-web/juke-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
let _Fields$cmpId, _Fields$cmpVersion, _Fields$consentLangua, _Fields$consentScreen, _Fields$created, _Fields$isServiceSpec, _Fields$lastUpdated, _Fields$policyVersion, _Fields$publisherCoun, _Fields$publisherLegi, _Fields$publisherCons, _Fields$purposeConsen, _Fields$purposeLegiti, _Fields$purposeOneTre, _Fields$specialFeatur, _Fields$useNonStandar, _Fields$vendorListVer, _Fields$version;
import { Fields } from '../model/index.js';
_Fields$cmpId = Fields.cmpId;
_Fields$cmpVersion = Fields.cmpVersion;
_Fields$consentLangua = Fields.consentLanguage;
_Fields$consentScreen = Fields.consentScreen;
_Fields$created = Fields.created;
_Fields$isServiceSpec = Fields.isServiceSpecific;
_Fields$lastUpdated = Fields.lastUpdated;
_Fields$policyVersion = Fields.policyVersion;
_Fields$publisherCoun = Fields.publisherCountryCode;
_Fields$publisherLegi = Fields.publisherLegitimateInterests;
_Fields$publisherCons = Fields.publisherConsents;
_Fields$purposeConsen = Fields.purposeConsents;
_Fields$purposeLegiti = Fields.purposeLegitimateInterests;
_Fields$purposeOneTre = Fields.purposeOneTreatment;
_Fields$specialFeatur = Fields.specialFeatureOptins;
_Fields$useNonStandar = Fields.useNonStandardStacks;
_Fields$vendorListVer = Fields.vendorListVersion;
_Fields$version = Fields.version;
export class BitLength {}
_defineProperty(BitLength, _Fields$cmpId, 12);
_defineProperty(BitLength, _Fields$cmpVersion, 12);
_defineProperty(BitLength, _Fields$consentLangua, 12);
_defineProperty(BitLength, _Fields$consentScreen, 6);
_defineProperty(BitLength, _Fields$created, 36);
_defineProperty(BitLength, _Fields$isServiceSpec, 1);
_defineProperty(BitLength, _Fields$lastUpdated, 36);
_defineProperty(BitLength, _Fields$policyVersion, 6);
_defineProperty(BitLength, _Fields$publisherCoun, 12);
_defineProperty(BitLength, _Fields$publisherLegi, 24);
_defineProperty(BitLength, _Fields$publisherCons, 24);
_defineProperty(BitLength, _Fields$purposeConsen, 24);
_defineProperty(BitLength, _Fields$purposeLegiti, 24);
_defineProperty(BitLength, _Fields$purposeOneTre, 1);
_defineProperty(BitLength, _Fields$specialFeatur, 12);
_defineProperty(BitLength, _Fields$useNonStandar, 1);
_defineProperty(BitLength, _Fields$vendorListVer, 12);
_defineProperty(BitLength, _Fields$version, 6);
_defineProperty(BitLength, "anyBoolean", 1);
_defineProperty(BitLength, "encodingType", 1);
_defineProperty(BitLength, "maxId", 16);
_defineProperty(BitLength, "numCustomPurposes", 6);
_defineProperty(BitLength, "numEntries", 12);
_defineProperty(BitLength, "numRestrictions", 12);
_defineProperty(BitLength, "purposeId", 6);
_defineProperty(BitLength, "restrictionType", 2);
_defineProperty(BitLength, "segmentType", 3);
_defineProperty(BitLength, "singleOrRange", 1);
_defineProperty(BitLength, "vendorId", 16);